import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledCardHeader = styled.div`
  ${({ theme }) =>
    `
      width: 100%;
      position: absolute;
      padding-block: ${utils.rem(theme.Spacing.Size.XSmall)};
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      align-self: stretch;
      z-index: ${theme.ZIndex.ZIndex.Elevated};
      & > div:first-child {
        padding-left: ${utils.rem(theme.Spacing.Size.XSmall)};
      };
    `}
`;

export const StyledCardHeaderButton = styled.div`
  ${({ theme }) =>
    `
      & button {
        background-color: ${theme.Color.NeutralsFixed.Gray};
      }
    `}
`;

export const StyledCardHeaderRightContainer = styled.div`
  ${({ theme }) =>
    `
      padding-right: ${utils.rem(theme.Spacing.Size.XSmall)};
      opacity: 0;
      display: flex;
      gap: ${utils.rem(theme.Spacing.Size.XXSmall)};
      margin: 0 0 0 auto;
    `}
`;
